export default {
  layout: (ctx) => {
    if (ctx.$device.isDesktop) {
      return 'primary-desktop';
    } else {
      return 'primary-mobile';
    }
  },
};
